import script from "./JobsearchCategorySuggestionsAggressive.vue?vue&type=script&setup=true&lang=js"
export * from "./JobsearchCategorySuggestionsAggressive.vue?vue&type=script&setup=true&lang=js"

import "./JobsearchCategorySuggestionsAggressive.vue?vue&type=style&index=0&id=7eb8bc4a&lang=css"

const __exports__ = script;

export default __exports__